(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_i2_commons_domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_i2_commons_domain.js'));
  else {
    if (typeof kotlin_city_smartb_i2_commons_domain === 'undefined') {
      throw new Error("Error loading module 'kotlin_city_smartb_i2_group_domain'. Its dependency 'kotlin_city_smartb_i2_commons_domain' was not found. Please, check whether 'kotlin_city_smartb_i2_commons_domain' is loaded prior to 'kotlin_city_smartb_i2_group_domain'.");
    }
    root.kotlin_city_smartb_i2_group_domain = factory(typeof kotlin_city_smartb_i2_group_domain === 'undefined' ? {} : kotlin_city_smartb_i2_group_domain, kotlin_city_smartb_i2_commons_domain);
  }
}(this, function (_, kotlin_city_smartb_i2_commons_domain) {
  //region block: imports
  var KeycloakF2Command = kotlin_city_smartb_i2_commons_domain.$crossModule$.KeycloakF2Command;
  var KeycloakF2Result = kotlin_city_smartb_i2_commons_domain.$crossModule$.KeycloakF2Result;
  //endregion
  'use strict';
  //region block: pre-declaration
  //endregion
  function GroupCreateCommand(name, attributes, roles, auth, realmId) {
    this.name_1 = name;
    this.attributes_1 = attributes;
    this.roles_1 = roles;
    this.auth_1 = auth;
    this.realmId_1 = realmId;
  }
  GroupCreateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  GroupCreateCommand.prototype._get_attributes__2098778644_ypk3ys_k$ = function () {
    return this.attributes_1;
  };
  GroupCreateCommand.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  GroupCreateCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  GroupCreateCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  GroupCreateCommand.$metadata$ = {
    simpleName: 'GroupCreateCommand',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(GroupCreateCommand.prototype, 'name', {
    configurable: true,
    get: GroupCreateCommand.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(GroupCreateCommand.prototype, 'attributes', {
    configurable: true,
    get: GroupCreateCommand.prototype._get_attributes__2098778644_ypk3ys_k$
  });
  Object.defineProperty(GroupCreateCommand.prototype, 'roles', {
    configurable: true,
    get: GroupCreateCommand.prototype._get_roles__3581820084_bsl7ws_k$
  });
  Object.defineProperty(GroupCreateCommand.prototype, 'realmId', {
    configurable: true,
    get: GroupCreateCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  function GroupCreatedResult(id) {
    this.id_1 = id;
  }
  GroupCreatedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GroupCreatedResult.$metadata$ = {
    simpleName: 'GroupCreatedResult',
    kind: 'class',
    interfaces: [KeycloakF2Result]
  };
  Object.defineProperty(GroupCreatedResult.prototype, 'id', {
    configurable: true,
    get: GroupCreatedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  function GroupUpdateCommand(id, name, attributes, roles, auth, realmId) {
    this.id_1 = id;
    this.name_1 = name;
    this.attributes_1 = attributes;
    this.roles_1 = roles;
    this.auth_1 = auth;
    this.realmId_1 = realmId;
  }
  GroupUpdateCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GroupUpdateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  GroupUpdateCommand.prototype._get_attributes__2098778644_ypk3ys_k$ = function () {
    return this.attributes_1;
  };
  GroupUpdateCommand.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  GroupUpdateCommand.prototype._get_auth__792765859_d3zq1v_k$ = function () {
    return this.auth_1;
  };
  GroupUpdateCommand.prototype._get_realmId__1266573383_ky329z_k$ = function () {
    return this.realmId_1;
  };
  GroupUpdateCommand.$metadata$ = {
    simpleName: 'GroupUpdateCommand',
    kind: 'class',
    interfaces: [KeycloakF2Command]
  };
  Object.defineProperty(GroupUpdateCommand.prototype, 'id', {
    configurable: true,
    get: GroupUpdateCommand.prototype._get_id__1413120976_ndc34g_k$
  });
  Object.defineProperty(GroupUpdateCommand.prototype, 'name', {
    configurable: true,
    get: GroupUpdateCommand.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(GroupUpdateCommand.prototype, 'attributes', {
    configurable: true,
    get: GroupUpdateCommand.prototype._get_attributes__2098778644_ypk3ys_k$
  });
  Object.defineProperty(GroupUpdateCommand.prototype, 'roles', {
    configurable: true,
    get: GroupUpdateCommand.prototype._get_roles__3581820084_bsl7ws_k$
  });
  Object.defineProperty(GroupUpdateCommand.prototype, 'realmId', {
    configurable: true,
    get: GroupUpdateCommand.prototype._get_realmId__1266573383_ky329z_k$
  });
  function GroupUpdatedResult(id) {
    this.id_1 = id;
  }
  GroupUpdatedResult.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GroupUpdatedResult.$metadata$ = {
    simpleName: 'GroupUpdatedResult',
    kind: 'class',
    interfaces: [KeycloakF2Result]
  };
  Object.defineProperty(GroupUpdatedResult.prototype, 'id', {
    configurable: true,
    get: GroupUpdatedResult.prototype._get_id__1413120976_ndc34g_k$
  });
  //region block: exports
  function $jsExportAll$(_) {
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$group = $i2$keycloak$f2.group || ($i2$keycloak$f2.group = {});
    var $i2$keycloak$f2$group$domain = $i2$keycloak$f2$group.domain || ($i2$keycloak$f2$group.domain = {});
    var $i2$keycloak$f2$group$domain$features = $i2$keycloak$f2$group$domain.features || ($i2$keycloak$f2$group$domain.features = {});
    var $i2$keycloak$f2$group$domain$features$command = $i2$keycloak$f2$group$domain$features.command || ($i2$keycloak$f2$group$domain$features.command = {});
    $i2$keycloak$f2$group$domain$features$command.GroupCreateCommand = GroupCreateCommand;
    $i2$keycloak$f2$group$domain$features$command.GroupCreatedResult = GroupCreatedResult;
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$keycloak = $i2.keycloak || ($i2.keycloak = {});
    var $i2$keycloak$f2 = $i2$keycloak.f2 || ($i2$keycloak.f2 = {});
    var $i2$keycloak$f2$group = $i2$keycloak$f2.group || ($i2$keycloak$f2.group = {});
    var $i2$keycloak$f2$group$domain = $i2$keycloak$f2$group.domain || ($i2$keycloak$f2$group.domain = {});
    var $i2$keycloak$f2$group$domain$features = $i2$keycloak$f2$group$domain.features || ($i2$keycloak$f2$group$domain.features = {});
    var $i2$keycloak$f2$group$domain$features$command = $i2$keycloak$f2$group$domain$features.command || ($i2$keycloak$f2$group$domain$features.command = {});
    $i2$keycloak$f2$group$domain$features$command.GroupUpdateCommand = GroupUpdateCommand;
    $i2$keycloak$f2$group$domain$features$command.GroupUpdatedResult = GroupUpdatedResult;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_city_smartb_i2_group_domain.js.map